
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AppLayout, FooterComponent, HeaderComponent, LayoutContentDirective, LayoutFooterDirective, LayoutHeaderDirective, LayoutNavigationDirective, NavigationComponent } from '@web-client/design-system';

@Component({
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    AppLayout,
    LayoutContentDirective,
    LayoutFooterDirective,
    LayoutHeaderDirective,
    LayoutNavigationDirective,
    NavigationComponent,
    HeaderComponent,
    FooterComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  // standalone: true,
})
export class App implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);



  ngOnInit() {
    // Check authentication status on app initialization
    // This restores the session from storage on page refresh
    this.oidcSecurityService.checkAuth().subscribe();
  }
}
